const parse = (string: string) => string.trim()

const isValid = (string: string) => string.includes('@') && string.length > 4

export default { parse, isValid }
